import React from 'react';
import _ from 'lodash';
import { HTML5Backend } from 'react-dnd-html5-backend';
// import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
/*
 * react-dndのラッパークラスを定義
 * react-dnd 参考ページ ↓
 * https://qiita.com/blues25/items/14b2ec1c461a831b9618
 * https://react-dnd.github.io/react-dnd/
 */

/*
 *   ドロップのコールバックを定義
 */
const drop_spec = {
  /* ドロップされた時のコールバック */
  drop(dropProps, monitor, dropComponent) {
    const dragProps = monitor.getItem(); // DragSource の props が取り出せる
    if (dropProps.onDropped) {
      dropProps.onDropped(dragProps, dropProps, monitor, dropComponent);
    }
    if (dragProps.onDrop) {
      dragProps.onDrop(dropProps, monitor, dropComponent);
    }
  },

  /* ホバーされた時のコールバック */
  hover(dropProps, monitor, dropComponent) {
    const dragProps = monitor.getItem();
    if (dropProps.onHover) {
      dropProps.onHover(dragProps, dropProps, monitor, dropComponent);
    }
    if (dragProps.onHover) {
      dragProps.onHover(dropProps, monitor, dropComponent);
    }
  },

  // eslint-disable-next-line no-unused-vars
  canDrop(props, monitor) {
    return true;
  },
};

/*
 *   ドラッグのコールバックを定義
 */
const drag_spec = {
  /* ドラッグ開始コールバック */
  beginDrag(props, monitor, component) {
    let result = null;
    if (props.onBeginDrag) {
      result = props.onBeginDrag(props, monitor, component);
    }

    if (_.isObject(result)) {
      return result;
    } else {
      return { drag_id: props.id };
    }
  },

  /* ドラッグ終了コールバック */
  endDrag(props, monitor, component) {
    let drop_result = monitor.getDropResult();

    if (props.onEndDrag) {
      props.onEndDrag(drop_result, props, monitor, component);
    }
  },

  /* ドラッグ可能関数, falseを返すとdragできなくなる */
  canDrag(props, monitor) {
    if (_.isFunction(props.canDrag)) {
      return props.canDrag(props, monitor);
    }
    if (props.canDrag === undefined) {
      return true;
    } // 未定義ならtrue
    return !!props.canDrag;
  },
};

/*
 *   react-dndで使うcollect関数
 */
const drop_collect = connect => ({
  connectDropTarget: connect.dropTarget(),
});

const drag_collect = connect => ({
  connectDragSource: connect.dragSource(),
});

/*
 *  ドロップとドラッグするための基盤
 *  この要素の子供しかドラッグ＆ドロップできない。
 */
class Space extends React.PureComponent {
  render() {
    return <div>{this.props.children || null}</div>;
  }
}

// DragDropContextは廃止されたため変更
// export const DragAndDropSpace = DragDropContext(HTML5Backend)(Space);
export const DragAndDropSpace = props => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Space {...props} />
    </DndProvider>
  );
};

/*
 *  ドロップに対応した Component
 */
class Target extends React.PureComponent {
  render() {
    const { connectDropTarget } = this.props;
    return connectDropTarget(this.props.children || null);
  }
}

export const DndDropTarget = DropTarget(
  props => props.id,
  drop_spec,
  drop_collect
)(Target);
/*
 *  ドラッグに対応した Component
 */
class Source extends React.PureComponent {
  render() {
    const { connectDragSource } = this.props;
    return connectDragSource(this.props.children || null);
  }
}

export const DndDragSource = DragSource(
  props => props.id,
  drag_spec,
  drag_collect
)(Source);

/*
 *  ドロップとドラッグ両方に対応した Component
 */
class SourceAndTarget extends React.PureComponent {
  render() {
    const { connectDragSource, connectDropTarget } = this.props;
    return connectDropTarget(connectDragSource(this.props.children || null));
  }
}

export const DragSourceAndDropTarget = DragSource(
  props => props.id,
  drag_spec,
  drag_collect
)(DropTarget(props => props.id, drop_spec, drop_collect)(SourceAndTarget));

export default {
  DragAndDropSpace,
  DropTarget,
  DndDropTarget,
  DragSourceAndDropTarget,
};



// WEBPACK FOOTER //
// ./src/components/DnDWrapper.js